import ClientPage from './Page';
export default ClientPage;
